import script from "./OperatorApplicationAuth.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperatorApplicationAuth.vue?vue&type=script&lang=ts&setup=true"

import "./OperatorApplicationAuth.vue?vue&type=style&index=0&id=5b9c4e0c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b9c4e0c"]])

export default __exports__